import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import getFolderOperation from 'owa-service/lib/operation/getFolderOperation';
import FolderInfoResponseMessage from 'owa-service/lib/contract/FolderInfoResponseMessage';
import folderId from 'owa-service/lib/factory/folderId';
import getFolderRequest from 'owa-service/lib/factory/getFolderRequest';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import folderResponseShape from 'owa-service/lib/factory/folderResponseShape';

// Type alias for storing possible values for additional properties.
type FolderProperties = 'UnreadCount' | 'TotalCount' | 'PermissionSet' | 'FolderDisplayName';

/**
 * This service command is used to fetch folder object from server with additional properties.
 * @param targetFolderId folder id for which folder permissions needs to be fetched.
 * @param additionalProperties additional properties that needs to be fetched.
 * @returns Promise object
 */
export default function getFolderWithAdditionalProperties(
    targetFolderId: string,
    additionalProperties: FolderProperties[]
): Promise<FolderInfoResponseMessage> {
    const constructedAdditionalProperties = additionalProperties.map(prop =>
        propertyUri({ FieldURI: prop })
    );
    return getFolderOperation({
        Header: getJsonRequestHeader(),
        Body: getFolderRequest({
            FolderShape: folderResponseShape({
                BaseShape: 'IdOnly',
                AdditionalProperties: constructedAdditionalProperties,
            }),
            FolderIds: [folderId({ Id: targetFolderId })],
        }),
    }).then(response => {
        return response.Body.ResponseMessages.Items[0];
    });
}
